import { createSelector } from "reselect";
import { adminSectionSelector } from "../admin_section_selector";

export const checkedFacilityIdsSelector = createSelector(
  adminSectionSelector,
  facilitySection => {
    return facilitySection.checkedFacilityIds;
  }
);
